import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const CashSales = () => {
  const [partyData, setPartyData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getParty = () => {
    setLoading(true);
    axios.post(API_URL.CASH_SALES_LIST, {}).then((res) => {
      if (res.data.status === 1) {
        setPartyData(res.data.data.data);
      }
      setLoading(false);
    },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const deleteParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Invoice No - " + row.party_name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CASH_SALES_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = partyData.filter((r) => r.id != row.id);
              setPartyData(newData);
              toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getParty();
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Cash Sales
            <small className="me-2">({partyData.length})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/sales/cash-sales/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              Case Sales
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>Party Name</th>
                        <th>Address</th>
                        <th>Invoice Date</th>
                        <th>Amount</th>
                        <th>Qty</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {partyData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{row.party_name}</td>
                            <td>
                              {row.party_address}
                            </td>
                            <td>
                              {row.date}
                            </td>
                            <td>{row.total_amount}</td>
                            <td>{row.total_qty}</td>
                            <td>
                              <Link
                                to={"/sales/cash-sales/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteParty(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CashSales;
